import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { afterItems, beforeItems } from '../data/content';
export function ShiftSection() {
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-242" data-mp="3uie8022nft8h">
      <div className="mx-auto w-full max-w-4xl" data-id="element-243" data-mp="3ug1hh0itsajt">
        <p className="text-center text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-cta" data-id="element-244" data-mp="2f3l5wakkv50">
          The shift
        </p>

        <h2 className="mt-4 text-center text-[24px] font-black leading-[1.15] tracking-tight text-navy sm:text-4xl" data-id="element-245" data-mp="q4fpoiuycf0z">
          From a dentist who has to remember everything…
          <span className="mt-2 block text-cta" data-id="element-246" data-mp="h26hhzn5oxqr">
            to a professional who has a structured blueprint for the case.
          </span>
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-247" data-mp="31t70idl7vtb3">
          <div className="rounded-3xl border border-[#E2574C]/25 bg-[#FDF3F2] p-5 sm:p-6" data-id="element-248" data-mp="31rm74ran2get">
            <div className="flex items-center gap-2.5" data-id="element-249" data-mp="36tv0vpvc5mhz">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#E2574C]" data-id="element-250" data-mp="vg2rv10uj7fu">
                <XIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-251" data-mp="qhrewhf98gte" />
              </span>
              <h3 className="text-sm font-black uppercase tracking-[0.14em] text-[#9B2F26]" data-id="element-252" data-mp="10ff9n7cv1obk">
                Before
              </h3>
            </div>

            <ul className="mt-5 space-y-3" data-id="element-253" data-mp="1edvq3q0iyt6w">
              {beforeItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-254" data-mp="19f2g47kg5kbh">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#E2574C]" strokeWidth={3} aria-hidden="true" data-id="element-255" data-mp="1o504oomagc17" />
                  <span className="text-[13.5px] leading-snug text-navy2 sm:text-[15px]" data-id="element-256" data-mp="1j89irknsym7v">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border border-cta/25 bg-skysoft p-5 sm:p-6" data-id="element-257" data-mp="207av40omyjyb">
            <div className="flex items-center gap-2.5" data-id="element-258" data-mp="205gcwu4r15xx">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-cta" data-id="element-259" data-mp="2575ny9rz1jm0">
                <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-260" data-mp="2a4fjm75yeria" />
              </span>
              <h3 className="text-sm font-black uppercase tracking-[0.14em] text-navy" data-id="element-261" data-mp="2iyk6kfhyvisj">
                With the Blueprint
              </h3>
            </div>

            <ul className="mt-5 space-y-3" data-id="element-262" data-mp="2nyosil1n95q5">
              {afterItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-263" data-mp="2stvn93cxr02x">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-264" data-mp="2xu08f6osgizh" />
                  <span className="text-[13.5px] font-medium leading-snug text-navy sm:text-[15px]" data-id="element-265" data-mp="13g8pthoheorw">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-266" data-mp="3bz0f6lw907gz">
          <CtaButton label="I want to plan with a Blueprint" subLabel="Instant digital access · 7-day guarantee" data-id="element-267" data-mp="37ygljsavvlzl" />
        </div>
      </div>
    </section>;
}